/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 18/02/22
 */

import React from 'react';

import useWorkplanVersion from '@/components/contexts/VersionContext/useWorkplanVersion';
import AllocationsTile from '@/components/pages/dashboard/tiles/ChartTile/AllocationsTile';
import useNavigateOptions from '@/components/contexts/NaviateContext/useNavigateOptions';
import RequestDetailsUpdate from '@/components/pages/dashboard/tiles/ChartTile/RequestDetailsUpdate';
import WorkplanAllocationUpdate from '@/components/pages/dashboard/tiles/ChartTile/WorkplanUpdate';
import { useWorkplan } from '@/components/contexts/WorkplanContext/useWorkplan';

const WorkplanAllocationsTile = () => {
    const { workplan } = useWorkplan();
    const { workplanVersion, loading: versionLoading, error: versionError } = useWorkplanVersion();
    const { supervisor, admin } = useNavigateOptions();

    return (
        <AllocationsTile
            workplanVersion={workplanVersion}
            loading={versionLoading}
            error={versionError}
            action={
                supervisor || admin ? (
                    <WorkplanAllocationUpdate />
                ) : (
                    <RequestDetailsUpdate assignment={workplan?.assignment} />
                )
            }
        />
    );
};

export default WorkplanAllocationsTile;
